<!--
 * Created by JackCui on 2021/10/18
 -->
<template>
  <div class="mod-popup-box">
    <slot/>
    <sy-popup
      v-if="visible"
      v-model="visible"
      :title="title"
      :size="pageSize"
      @close="close"
    >
      <component
        ref="paasPage"
        :key="componentKey"
        :is="componentName"
        :pageParams="params"
        :pageConfig="pageConfig"
        :configType="configType"
        @loaded="loaded"
      />
      <template slot="footer" v-if="loading">
        <buttons-render :node="nodes" />
      </template>
    </sy-popup>
  </div>
</template>

<script>
  import response from '../../../../../../../utils/response'
  import paasApi from '../../../../../../business/paas/custom/edit/api'
  import Edit from '../../../../../../business/paas/custom/edit/edit.vue'
  import Detail from '../../../../../../business/paas/custom/detail/detail.vue'
  import i18n from '../../../../../../business/paas/custom/edit/i18n'
  import {BUTTON_API_NAME} from 'fe-coms-share/paas/constants'
  import {parentVm} from '../../../../utils/emitter.js'
  import {merge} from 'lodash-es'

  const pageText = window.fe.getPageText(i18n)
  export default {
    name: 'popup-window',
    components: {
      Edit,
      Detail
    },
    provide () {
      return {
        popupParams: this.params
      }
    },
    inject: ['store'],
    data () {
      return {
        componentKey: 0,
        visible: false,
        nodes: {},
        loading: false,
        pageConfig: {},
        componentName: '',
        params: {}
      }
    },
    computed: {
      title () {
        return this.nodes.info?.title || ''
      },
      pageSize () {
        return this.nodes.info?.pageSize || 'hidden'
      },
      paasPage () {
        return this.$refs['paasPage'].paasPage
      },
      popupConfig () {
        const {objectApiName, layoutApiName} = this.params
        return this.store?.popupConfig?.[objectApiName]?.[layoutApiName]
      },
      configType () {
        return this.popupConfig && 'popupConfig'
      }
    },
    methods: {
      loaded (schema) {
        this.nodes = schema.nodes
        this.loading = true
      },
      initParams (buttonItem, linkObjectModel, row = {}) {
        const {objectApiName, layoutApiName, operationApiName, tenantType, config} = linkObjectModel
        this.componentName = config.componentName
        Object.assign(
          this.params,
          {
            layoutApiName,
            objectApiName,
            tenantType,
            permissionPointCode: operationApiName,
            id: row.aPaaS_SequenceId,
            row
          }
        )
        this.$set(
          this.pageConfig,
          objectApiName,
          merge({
            buttons: {
              [BUTTON_API_NAME.BUTTON_BACK]: {
                event: {
                  click: this.onClose
                }
              },
              [BUTTON_API_NAME.BUTTON_SUBMIT]: {
                event: {
                  submit: this.handleSubmit
                }
              }
            }
          }, this.popupConfig)
        )
      },
      openWindow (buttonItem, linkObjectModel, row) {
        // 每次重新打开弹窗都刷新组件
        this.componentKey += 1
        this.initParams(buttonItem, linkObjectModel, row)
        this.visible = true
      },
      onClose () {
        this.visible = false
        this.params.id = ''
        this.componentName = ''
        this.nodes = {}
      },
      // 提交
      async handleSubmit ({data, headerParams, isEdit}) {
        let api = isEdit ? paasApi.valueUpdate : paasApi.valueCreate
        const { objectApiName, operationApiName } = this.params
        const _url = `${api.url}/${objectApiName}/${operationApiName}`
        const promise = this.$http(api.type, _url, data, headerParams)
        const res = await response(promise, {
          loadingOptions: {
            text: pageText.submission
          }
        })
        if (res.isOk) {
          this.$message({
            message: pageText.submitSuccessfully,
            type: 'success'
          })
          this.onClose()
          // 更新列表数据
          const paasList = parentVm.call(this, 'page-list')
          paasList && paasList.fetchHandle()
        }
      }
    }
  }
</script>
